// ANCHOR SMOOTH SCROLL
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href*="#"]').forEach(function(link) {
    if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '#0') {
      link.addEventListener('click', function(event) {
        var hash = this.hash.slice(1);
        var target = document.querySelector(this.hash);
        target = target ? target : document.querySelector('[name=' + hash + ']');
        if (target) {
          event.preventDefault();
          window.scrollTo({
            top: target.offsetTop,
            behavior: 'smooth'
          });
        }
      });
    }
  });
});